"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = OptionWithCheckbox;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _material = require("@mui/material");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _react = _interopRequireDefault(require("react"));
var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    optionWithCheckbox: {
      '&:hover': {
        backgroundColor: "".concat(theme.palette.action.hover, " !important")
      }
    }
  };
});
function OptionWithCheckbox(_ref) {
  var children = _ref.children,
    data = _ref.data,
    innerProps = _ref.innerProps,
    isDisabled = _ref.isDisabled,
    isFocused = _ref.isFocused,
    isSelected = _ref.isSelected,
    selectProps = _ref.selectProps;
  var classes = useStyles();
  var theme = (0, _material.useTheme)();
  var id = data.id,
    selectAll = data.selectAll;
  return /*#__PURE__*/_react.default.createElement(_material.MenuItem, (0, _extends2.default)({
    className: classes.optionWithCheckbox,
    component: "div",
    disabled: isDisabled || !selectProps.canDeleteInitialValue && selectProps.initialValue && !!selectProps.initialValue.find(function (initialValue) {
      return data.value === initialValue;
    }),
    disableGutters: true,
    selected: isFocused,
    style: (0, _extends2.default)({
      alignItems: 'center',
      display: 'flex',
      fontWeight: isSelected ? 500 : 400,
      width: '100%'
    }, selectAll && {
      borderBottom: "2px solid ".concat(theme.palette.action.disabled),
      fontWeight: 500
    })
  }, innerProps, {
    id: id
  }), /*#__PURE__*/_react.default.createElement(_material.Checkbox, {
    checked: isSelected || selectAll === selectProps.allSelected,
    color: "primary",
    id: "".concat(id, "Checkbox")
  }), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      flex: '1 1 100%',
      marginRight: '8px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  }, children));
}